import React, { useContext, useEffect, useRef, useState } from 'react'
import './Trancontents.css'
import milkcan from "../../imgs/milkcan.png";
import khadya from "../../imgs/khadya.png";
import milkvan from "../../imgs/milkvan.png";
import ratib from "../../imgs/ratib.webp";
import shares from "../../imgs/shares.png";
import cash from "../../imgs/cash.png";
import retan from "../../imgs/retan.png";
import sanghpur from "../../imgs/sanghpur.png";
import Box from '../Box/Box';
import Cowleft from "../../imgs/cowleft.gif";
import Newcustomer from '../Newcustomer/Newcustomer';
import Newkendra from '../Newkendra/Newkendra';
import { useNavigate } from 'react-router-dom';
import Dialog from '../Dialog/Dialog';
import Ratetable from '../Ratetable/Ratetable';
import Setting from '../Settings/Settings';
import Nrepair from '../Nrepair/Nrepair';
import Sanklan from '../Sanklan/Sanklan'
import Sanklanbykno from '../Sanklanbykno/Sanklanbykno'
import Globalcontext from '../../Context/Globalcontext';
import Khpur from '../Khpur/Khpur';
import Khsale from '../Khsale/Khsale';
import qr from "../../imgs/QR.png";
import Uchal from '../Uchal/Uchal';
import Shares from '../Shares/Shares';
import Sanghvikri from '../Sanghvikri/Sanghvikri';
import Ratibvikri from '../Ratibvikri/Ratibvikri';
import Ratibjma from '../Ratibjma/Ratibjma';
import Khpurjma from '../Khpurjma/Khpurjma';
import Khadyajma from '../Khadyajma/Khadyajma';
import Retanmedi from '../Retanmedi/Retanmedi';
import Ratibsabhasad from '../Ratibsabhasad/Ratibsabhasad';
import Ratibjamasabh from '../Ratibjmasabh/Ratibjmasabh';
import Karj from '../Karj/Karj';
import Sanghkharedi from '../Sanghkharedi/Sanghkharedi';

import { useTranslation } from "react-i18next";

const Trancontents = (props) => {

    const [mastermenu, setMastermenu] = useState(true);
    const [showBackImage, setShowBackImage] = useState(false);
    const [transitionEnded, setTransitionEnded] = useState(true);
    const [kopen, setkopen] = useState(0);

    const { submenu, setsubmenu } = useContext(Globalcontext);
    const { sanksource, setHeadname } = useContext(Globalcontext);

    const [t] = useTranslation();

    const refprint = useRef(null);
    const refprintclose = useRef(null);

    const [daysRemaining, setDaysRemaining] = useState(0);
    const [expirebox, setExpirebox] = useState(false);

    const navigate = useNavigate();

    const [dialog, setDialog] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    const handlePrint = () => {
        refprint.current?.click();
    }

    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return `${day} ${monthNames[monthIndex]} ${year}`;
    }

    const handleprintclose = () => {
        refprintclose.current?.click();
    }

    const areUSure = () => {
        handleDialog("", false);
    };

    const handleDialog = (message, isLoading, nameProduct) => {
        setDialog({ message, isLoading, nameProduct });
    };

    const showdialog = () => {
        setkopen(1);
        handleDialog(t("dialog.kendra_not_available"), true, t("dialog.create_new_kendra"));
    }

    const openkendra = () => {
        setShowBackImage(true);
        setMastermenu(false);
        setTransitionEnded(true);
        setsubmenu("kendra");
        setkopen(1);
    }

    useEffect(() => {

        if (localStorage.getItem("kendra") === "Not available" && kopen === 0) {
            showdialog();
        } else {
            if (sanksource === "custback") {
                setsubmenu("sanklan")
                setShowBackImage(true);
                setMastermenu(false);
                setTransitionEnded(true);
            }
        }

        if (localStorage.getItem("contact") === "" || localStorage.getItem("contact") === null) {
            navigate("/");
            localStorage.setItem("status", "");
            localStorage.setItem("contact", "");
        }

        // (Your expiry logic is commented in original, kept same)
    }, [])

    const visibility = () => {
        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        setsubmenu("");
        setHeadname(t("head.daily")); // ✅ translated
    }

    const handleTransitionEnd = () => {
        if (!mastermenu) setShowBackImage(true);
        else setShowBackImage(false);
        setTransitionEnded(true);
    };

    const logout = () => {
        localStorage.setItem("status", "");
        localStorage.setItem("contact", "");
        localStorage.setItem("contactplant", "");
        localStorage.setItem("kendra", "Not available");
        localStorage.setItem("kmobno", "");
        localStorage.setItem("ksr", "");
        localStorage.setItem("vdate", "");

        localStorage.setItem("name", "");
        localStorage.setItem("city", "");
        localStorage.setItem("tal", "");
        localStorage.setItem("dist", "");
        localStorage.setItem("username", "");
        localStorage.setItem("mobile", "");
        localStorage.setItem("bill10type", "");
        localStorage.setItem("plant", "");
        localStorage.setItem("parent", "");
        localStorage.setItem("suchana", "");
        localStorage.setItem("thevper", "");
        localStorage.setItem("dur", "");
        localStorage.setItem("digri", "");

        localStorage.setItem("lastbilldate", "Not available");
        localStorage.setItem("custlist", "");
        localStorage.setItem("mhrates", "");
        localStorage.setItem("gayrates", "");
        localStorage.setItem("treport", "");
        localStorage.setItem("mhrates9", "");
        localStorage.setItem("gayrates9", "");
        localStorage.setItem("sanghlist", "");

        localStorage.setItem("thevregular", "");
        localStorage.setItem("thev1", "");
        localStorage.setItem("thev2", "");
        localStorage.setItem("thev3", "");
        localStorage.setItem("advchalu", "");
        localStorage.setItem("advkapat", "");
        localStorage.setItem("khchalu", "");
        localStorage.setItem("khkapat", "");
        localStorage.setItem("ratibchalu", "");
        localStorage.setItem("ratibkapat", "");
        localStorage.setItem("hptachalu", "");
        localStorage.setItem("intrchalu", "");
        localStorage.setItem("sanghkchalu", "");
        localStorage.setItem("sanghkkapat", "");
        localStorage.setItem("retanchalu", "");
        localStorage.setItem("retankapat", "");
        localStorage.setItem("kapat1", "");
        localStorage.setItem("kapat2", "");
        localStorage.setItem("kapat3", "");
        localStorage.setItem("vahtuk", "");
        localStorage.setItem("comm", "");
        localStorage.setItem("ada", "");
        localStorage.setItem("billamt", "");

        props.setProgress(50);
        setTimeout(() => props.setProgress(100), 200);
        navigate("/");
    }

    return (
        <>
            {/* Expiry modal (kept, translated) */}
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden={true}
                ref={refprint}
                data-bs-target="#printinput"
            />

            <div className="modal fade" id="printinput" tabIndex="-1" role="dialog" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprintclose} aria-label="Close" />
                        </div>

                        <div className="modal-body">
                            <h5 className="modal-title">{t("expiry.title")}</h5>
                            <span className='note'>{t("expiry.note")}</span>
                        </div>

                        <div className="expiry">
                            <span className='noteblue'>
                                {t("expiry.line1", {
                                    date: formatDate(localStorage.getItem("vdate")),
                                    days: daysRemaining
                                })}
                            </span>
                            <span className='noteblue'>{t("expiry.line2")}</span>
                            <span className='noteblue'>{t("expiry.line3")}</span>
                            <span className='noteblue'>{t("expiry.line4")}</span>

                            <span className='noteblack'>{t("expiry.scan_qr")}</span>
                            <img className='qrimg' src={qr} alt="" />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>
                                {t("common.close")}
                            </button>
                            <button type="button" className="btn btn-danger" onClick={handleprintclose}>
                                {t("common.ok")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='line' />
            <div className="maincon">

                <span className={`heading1 ${mastermenu ? '' : 'hidden'}`}>{t("head.daily")}</span>

                <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
                    <Box
                        action="sanklan"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t4dark), var(--t4dark))"}
                        head={t("tran.boxes.sanklan")}
                        img={<img src={milkcan} alt="" />}
                    />

                    <Box
                        action="sanghvikri"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t5dark), var(--t5dark))"}
                        head={t("tran.boxes.sangh_vikri")}
                        img={<img src={milkvan} alt="" />}
                    />

                    <Box
                        action="ratibvikri"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"}
                        head={t("tran.boxes.ratib_vikri")}
                        img={<img src={ratib} alt="" />}
                    />

                    <Box
                        action="khadya_kharidi"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t6dark), var(--t6dark))"}
                        head={t("tran.boxes.khadya_kharidi")}
                        img={<img src={khadya} alt="" />}
                    />

                    <Box
                        action="khadya_vikri"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t3dark), var(--t3dark))"}
                        head={t("tran.boxes.khadya_vikri")}
                        img={<img src={khadya} alt="" />}
                    />

                    <Box
                        action="uchal"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t1dark), var(--t1dark))"}
                        head={t("tran.boxes.uchal")}
                        img={<img src={cash} alt="" />}
                    />

                    {localStorage.getItem("retan") === "On" ? (
                        <Box
                            action="retanmedi"
                            setsubmenu={setsubmenu}
                            visibility={visibility}
                            background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"}
                            head={t("tran.boxes.retanmedi")}
                            img={<img src={retan} alt="" />}
                        />
                    ) : null}

                    {localStorage.getItem("sanghk") === "On" ? (
                        <Box
                            action="dynamic_sangh_name"
                            setsubmenu={setsubmenu}
                            visibility={visibility}
                            background={"linear-gradient(179deg, var(--t3dark), var(--t3dark))"}
                            head={localStorage.getItem("sanghkname")}
                            img={<img src={sanghpur} alt="" />}
                        />
                    ) : null}

                
                </div>

                <div className={`rowbox ${mastermenu ? '' : 'hidden'}`}>
                    <div className="first"></div>
                    <div className="second">
                        <div className='line' />
                        <span className='firstspan'>{t("tran.info.1")}</span>
                        <span className='infospan'>{t("tran.info.2")}</span>
                        <span className='infospan'>{t("tran.info.3")}</span>
                    </div>
                </div>

                <div className={`cust ${mastermenu ? 'hidden' : ''}`}>
                    {transitionEnded && showBackImage && (
                        submenu === "customer" ? <Newcustomer setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                            submenu === "kendra" ? <Newkendra setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                submenu === "ratetable" ? <Ratetable setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                    submenu === "settings" ? <Setting setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                        submenu === "nrepair" ? <Nrepair setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                            submenu === "sanklan" ? <Sanklan setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                submenu === "sanklanbykno" ? <Sanklanbykno setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                    submenu === "sanghvikri" ? <Sanghvikri setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                        submenu === "ratibvikri" ? <Ratibvikri setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                            submenu === "retanmedi" ? <Retanmedi setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                submenu === "ratibjma" ? <Ratibjma setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                    submenu === "khadyajma" ? <Khadyajma setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                        submenu === "kpur" ? <Khpur setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                            submenu === "khpurjma" ? <Khpurjma setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                submenu === "ksale" ? <Khsale setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                    submenu === "uchal" ? <Uchal setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                        submenu === "shares" ? <Shares setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                            submenu === "Ratibsabh" ? <Ratibsabhasad setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                                submenu === "ratibjmasabh" ? <Ratibjamasabh setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                                    submenu === "karj" ? <Karj setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                                        submenu === localStorage.getItem("sanghkname") ? <Sanghkharedi setsubmenu={setsubmenu} setKendraValue={props.setKendraValue} setkopen={setkopen} setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                                                                                            ""
                    )}
                </div>

            </div>

            <div className="secrow">
                <div className="leftsecrow"></div>
                {submenu !== "sanklan" && submenu !== "sanklanbykno" && submenu !== "sanghvikri" && submenu !== "ratibvikri" && submenu !== "ratibsabh" && submenu != "kpur" && submenu != "ksale" && submenu != "khadyajma" && submenu != "ksale" && submenu != "uchal" && submenu != "ratibjma" && submenu != "khpurjma" && submenu != "retanmedi" && submenu != "ratibjmasabh" && submenu != "Ratibsabh" && submenu != "karj" && submenu != "sanghpur" && submenu != "shares" ?
                    <div className="imgcon">
                        <img className='imgcowtran' src={Cowleft} alt="" />
                    </div>
                    : ""
                }
            </div>

            {dialog.isLoading && (
                <Dialog
                    submessage={dialog.nameProduct}
                    onDialog={areUSure}
                    message={dialog.message}
                    functionname={openkendra}
                    button1text={t("dialog.no")}
                    button2text={t("dialog.yes")}
                />
            )}
        </>
    )
}

export default Trancontents
